/** "supervisor hold" → "SUPERVISOR_HOLD" (the server's A–Z0–9_ code format). */
export function toCode(v: string): string {
  return v
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
}
